import { WithEventsProps } from 'enhancers/withEventsState';
import * as _ from 'lodash';
import * as React from 'react';
import { Subtract } from 'utility-types';

type RequiredProps = WithEventsProps;

interface IOption<T> {
  value: T;
  label: string;
}

interface IEventsStateProviderProps {
  value: IOption<string> | false;
  onChange: (option: IOption<string>) => void;
}

const stateProvider = <P extends IEventsStateProviderProps>(
  Component: React.ComponentType<P>
): React.SFC<
  Subtract<P, IEventsStateProviderProps> & RequiredProps
> => props => {
  const value = !!props.events.countryFilter.length && {
    label: props.events.countryFilterLabel,
    value: props.events.countryFilter
  };

  const onChange = (option: IOption<string>) =>
    props.setCountry({ country: option.value, label: option.label });

  return <Component value={value} onChange={onChange} {...props} />;
};

export default stateProvider;



// WEBPACK FOOTER //
// ./src/components/CountrySelector/stateProvider.tsx